module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust3_m.920e87a28ef012e693c196f938740c28.png";